import { ShiftReportsService } from "@/modules/shiftReports/service";
import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";

export const useShiftReportQuery = (shiftReportId: string) => {
  const queryFn = useCallback(() => {
    return ShiftReportsService.get(shiftReportId);
  }, [shiftReportId]);

  return useQuery({
    queryKey: ["shiftReport", shiftReportId],
    queryFn,
  });
};
